/*******************************************************************************
RESTORE HIDDEN IMAGES SO CLOUDINARY CAN PROCESS THEM
Restore the responsive class to the hidden images so Cloudinary can process them
*******************************************************************************/

export default function restoreHiddenImages() {
    // Restore the responsive class to the hidden images
    $('.cld-responsive-hidden').addClass('cld-responsive').removeClass('cld-responsive-hidden');
}
